// Module
var code = `<div id="page-header">







  </div>





<div id="page-body">


</div>
`;
// Exports
module.exports = code;